namespace GeniuzPOS.InitialData {
    export enum TextAlign {
        Left = 0,
        Center = 1,
        Right = 2
    }
    Serenity.Decorators.registerEnumType(TextAlign, 'GeniuzPOS.InitialData.TextAlign');
}
